import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * トップページ　PROJECTスライダー
*/
const topAboutSlider = () => {

    const swiper = new Swiper('.js_topAboutSlider', {
        loop: true,
        slidesPerView: 'auto',
        speed: 6000,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
    });
}

export default topAboutSlider;